import React, { Component } from "react";
import { BrowserRouter as Router, useLocation, Switch } from "react-router-dom";
import AsyncComponent from "../hoc/async.component";
import UpdateCompanyRequest from "../pages/user/new_user/start_company/company_reg_form_update";
import AdminRoute from "./components/admin";
import AdminAuthRoute from "./components/adminAuth";
import AuthRoute from "./components/auth";
import AuthNoLayoutRoute from "./components/authNoLayout";
import CompanyAuthRoute from "./components/companyAuth";
import ErrorRoute from "./components/error";
import PrivateRoute from "./components/private";
import PublicRoute from "./components/public";
import RegRoute from "./components/regroute";
import { TransitionGroup, CSSTransition } from "react-transition-group";

// Layout

import Layout from "../layout/userlayout/layout.component";
import AdminLayout from "../layout/adminlayout/layout.component";

// Pages

// Auth Pages
import AdminLogin from "../pages/auth/login/adminlogin";
import CompanyLogin from "../pages/auth/login/companylogin";
import Login from "../pages/auth/login/login";
import Userlogin from "../pages/auth/login/userlogin";
import SignUp from "../pages/auth/login/signup";
import Otp from "../pages/auth/otp/otp";
import SwitchAccount from "../pages/auth/switch/SwitchAccount";
import Verify from "../pages/auth/verify/verify";

// User Pages

import DashBoard from "../pages/user/dashboard/dashboard";
import Tenders from "../pages/user/tenders/tenders";
import Publications from "../pages/user/publications/publications";
import ProjectProposal from "../pages/user/project_proposal/addproposal";

import ProposalDirectory from "../pages/user/proposaldirectory/directory";
import ProfessionalBodies from "../pages/user/professional_bodies/list";
import ResourcePersonalList from "../pages/user/resource_personal/list";
import ResourcePersonalDetails from "../pages/user/resource_personal/details/details";
import ResourcePersonalReg from "../pages/user/resource_personal/manage/regform";
// -----------
import ExpertManpowerList from "../pages/user/expert_manpower/list";
import KSPACEAdvisors from "../pages/user/kspace-advisors/list.js";
import Candidates from "../pages/user/candidates/list.js";
import CandidateProfiles from "../pages/user/downloadedCandidates/list.js";
import ExpertManpowerDetails from "../pages/user/expert_manpower/details/details";
import AdvisorDetails from "../pages/user/kspace-advisors/details/details.js";
import CandidateDetails from "../pages/user/candidates/details/details.js";
import CandidateDownloadedDetails from "../pages/user/downloadedCandidates/details/details.js";
import ExpertManpowerReg from "../pages/user/expert_manpower/manage/regform";
import CandidatesReg from "../pages/user/candidates/manage/regform.js";
// ----------------
import InternshipProposalsList from "../pages/user/internship_proposals/list.js";
import InternshipProposalsForm from "../pages/user/internship_proposals/manage/regform.js";
import InternshipProposalDetail from "../pages/user/internship_proposals/detail.js";
import InternshipApplicantProfile from "../pages/user/internship_proposals/applicant_profile.js";
import RegisteredInternships from "../pages/user/registered_internships/list.js";
import InternshipApplicationDetails from "../pages/user/registered_internships/details.js";
import RegisteredInternshipsHistory from "../pages/user/registered_internships/history.js";
import CompletedInternshipDirectory from "../pages/user/internship_directory/completed.js";
import AbsorbedInternshipDirectory from "../pages/user/internship_directory/absorbed.js";
import KSpaceMessages from "../pages/user/messages/list.js";
// ----------------
import TrainingReg from "../pages/user/academic_institution/training/manage/regform";
import TrainingList from "../pages/user/academic_institution/training/list";
import Contact from "../pages/user/contact/contact";
// import Faq from "../pages/user/faq/faq"
import Faqs from "../pages/user/faq/faq.js";
import TrainingDetail from "../pages/user/academic_institution/training/detail";
import StudentProposal from "../pages/user/academic_institution/proposal/proposallist";
import InstituteList from "../pages/user/academic_institution/institution/list";
import BusinessProposalList from "../pages/user/project_proposal/list";
import TechTransProposalList from "../pages/user/technology_proposal/list";
import InstituteReg from "../pages/user/academic_institution/institution/manage/regform";
import VendorsReg from "../pages/user/vendors/institution/manage/regform.js";
import VendorsUpdate from "../pages/user/vendors/institution/manage/updatereg.js";
import ProposalReg from "../pages/user/academic_institution/proposal/manage/regform";
import ProposalList from "../pages/user/academic_institution/proposal/list";
// ------------
import News from "../pages/public/latestnews/newsdetail";
import NewCompanyRequest from "../pages/user/new_user/start_company/company_reg_form";
import VendorEdit from "../pages/user/vendors/institution/manage/updatereg.js";
import DirectoryofCompany from "../pages/user/new_user/companies_international/view";
import Registrationkerala from "../pages/user/new_user/companies_kerala/registrationform";
import Directorykerala from "../pages/user/new_user/companies_kerala/view";
import Registrationindia from "../pages/user/new_user/companies_india/registrationform";
import Directoryindia from "../pages/user/new_user/companies_india/view";
import Registrationkspace from "../pages/user/new_user/companies_kspace/registrationform";
import Directorykspace from "../pages/user/new_user/companies_kspace/view";
import DirectoryOwnPremises from "../pages/user/new_user/companies_kspace/viewOwn.js";
import DirectoryOngoing from "../pages/user/new_user/companies_kspace/viewOngoing.js";
import ViewCompleted from "../pages/user/new_user/companies_kspace/viewCompleted.js";
import ViewCompletedKspace from "../pages/user/new_user/companies_kspace/viewCompletedKspace.js";
import ViewCompletedOwn from "../pages/user/new_user/companies_kspace/viewCompletedOwn.js";
///  admin ages

import AdminDashboard from "../pages/admin/admin_dashborad";
import RequestList from "../pages/admin/companyRequest/companyRequestlist";
import RequestView from "../pages/admin/companyRequest/companyRequestview";
import LoginAnalytics from "../pages/admin/settings/loginAnalytics";
import LoginLogs from "../pages/admin/settings/loginLogs";
import LoginLogDetails from "../pages/admin/settings/loginLogDetails";
import SuperRequestList from "../pages/admin/companyRequest/superAdmin/companyRequestview";
import BulkEmail from "../pages/admin/companyRequest/bulkEmail";
import BannerList from "../pages/admin/homepageManagement/banners/bannerList";
import PoliciesList from "../pages/admin/policies/policiesList";
import NewsLists from "../pages/public/news/policies";
import Incentives from "../pages/public/incentives/policies";
import IncentivesList from "../pages/admin/incentives/incentivesList";
import NewsList from "../pages/admin/news/newsList";
import BannerAdd from "../pages/admin/homepageManagement/banners/bannerAdd";
import AccomplishmentList from "../pages/admin/homepageManagement/accomplishment/accomplishmentList";
import AdvertisementList from "../pages/admin/homepageManagement/Advertisement/advertisementList.js";
import AdvertisementDetails from "../pages/admin/homepageManagement/Advertisement/manage/adDetails.js";
import AdvertisementEdit from "../pages/admin/homepageManagement/Advertisement/manage/adEdit.js";
import AdvertisementAdd from "../pages/admin/homepageManagement/Advertisement/manage/adAdd.js";

import ScrollList from "../pages/admin/homepageManagement/scrolling/scrollingList";
import ScopeList from "../pages/admin/homepageManagement/scopeActivity/scopeActivitylist";
import QuoteList from "../pages/admin/homepageManagement/quotes/quotesList";
import MaintextList from "../pages/admin/homepageManagement/aboutusMaintext/maintextList";
import OrganizationList from "../pages/admin/homepageManagement/aboutusOrganization/organizationList";
import DomainList from "../pages/admin/domain/domainList";
import QualificationList from "../pages/admin/qualification/qualifications.js";
import TenderCategoryList from "../pages/admin/tenderCategory/tenderCategory.js";
import TenderOrganizationList from "../pages/admin/tenderOrganization/tenderOrganization.js";
import ProfessionalBodiesList from "../pages/admin/professionalBodies/professionalBodiesList";

import CompaniesKeralaList from "../pages/admin/companiesKerala/companiesList";
import CompaniesKeralaBulkEmail from "../pages/admin/companiesKerala/bulkEmail";
import CompaniesNewKspace from "../pages/admin/companiesKspace/add";
import CompaniesNewKerala from "../pages/admin/companiesKerala/add";
import CompaniesNewIndia from "../pages/admin/companiesIndia/add";
import CompaniesNewInternational from "../pages/admin/companiesInternational/add";
import CompaniesNewViewKerala from "../pages/admin/companiesKerala/view";
import CompaniesNewViewKspace from "../pages/admin/companiesKspace/view";
import CompaniesNewViewIndia from "../pages/admin/companiesIndia/view";
import CompaniesNewViewInternational from "../pages/admin/companiesInternational/view";
import CompaniesInKspace from "../pages/admin/companiesKspace/companiesUnderKspace";
import CompaniesIndiaList from "../pages/admin/companiesIndia/companiesList";
import CompaniesInternationalList from "../pages/admin/companiesInternational/companiesList";
import ResourceList from "../pages/admin/resourcePerson/resourceList.js";
import ResourceBulkEmail from "../pages/admin/resourcePerson/bulkEmail";
import ResourceView from "../pages/admin/resourcePerson/view";
import CandidateView from "../pages/admin/candidates/view.js";
import ProfilesView from "../pages/admin/downloadedProfiles/view.js";
import ResourceAdd from "../pages/admin/resourcePerson/add";
import ManpowerList from "../pages/admin/manpower/manpowerList";
import ManpowerBulkEmail from "../pages/admin/manpower/bulkEmail";
import CandidatesList from "../pages/admin/candidates/manpowerList.js";
import CandidatesBulkEmail from "../pages/admin/candidates/bulkEmail";
import ProfilesList from "../pages/admin/downloadedProfiles/manpowerList.js";
import DetailedProfileList from "../pages/admin/downloadedProfiles/usersList.js";
import ManpowerAdd from "../pages/admin/manpower/add";
import ManpowerView from "../pages/admin/manpower/view";
import ProfessionalAdd from "../pages/admin/professionalBodies/add";
import ProfessionalEdit from "../pages/admin/professionalBodies/edit";
import ProfessionalView from "../pages/admin/professionalBodies/view";
import TenderList from "../pages/admin/marketResearch/tender/tenderList";
import TradeList from "../pages/admin/marketResearch/trade/tradeList.js";
import CareerList from "../pages/admin/marketResearch/career/careerList";
import PublicationList from "../pages/admin/marketResearch/publication/publicationList";
import ProjectProposalList from "../pages/admin/buisnessIdeas/projectProposal/projectList";
import ProjectProposalView from "../pages/admin/buisnessIdeas/projectProposal/view";
import TransferProposalList from "../pages/admin/buisnessIdeas/transferProposal/transferList";
import TransferProposalView from "../pages/admin/buisnessIdeas/transferProposal/view";
import AcademicInstitutionList from "../pages/admin/academicInstitution/academicInstitution/academicInstitutionList";
import AcademicInstitutionBulkEmail from "../pages/admin/academicInstitution/academicInstitution/bulkEmail";
import AcademicInstitutionView from "../pages/admin/academicInstitution/academicInstitution/view";
import AcademicInstitutionAdd from "../pages/admin/academicInstitution/academicInstitution/add";
import InstitutionProposalList from "../pages/admin/academicInstitution/institutionProposal/institutionProposalList";
import InstitutionProposalView from "../pages/admin/academicInstitution/institutionProposal/view";
import IntershipTrainingList from "../pages/admin/academicInstitution/intershipTraining/intershipTrainingList";
import IntershipTrainingView from "../pages/admin/academicInstitution/intershipTraining/view";
import IntershipTrainingAdd from "../pages/admin/academicInstitution/intershipTraining/add";
import AdminInternshipRequestsList from "../pages/admin/internshipRequests/list";
import AdminInternshipRequestDetail from "../pages/admin/internshipRequests/detail";
import InternshipApplicationsList from "../pages/admin/internshipApplications/list";
import InternshipApplicationDetail from "../pages/admin/internshipApplications/detail";
import InternshipsDoingList from "../pages/admin/internshipRequests/internshipsDoingList";
import InternshipsCompletedList from "../pages/admin/internshipRequests/internshipsCompletedList";
import InternshipsAbsorbedList from "../pages/admin/internshipRequests/internshipsAbsorbedList";
import AreaManagement from "../pages/admin/areamanagement/areamanagement";
import BuiltUp from "../pages/admin/areamanagement/builtupSpace";
import EquipedFacilty from "../pages/admin/areamanagement/euipedfacility";
import LandOnLease from "../pages/admin/areamanagement/landon";
import JoinrVenture from "../pages/admin/areamanagement/jointventure";
import OwnLand from "../pages/admin/areamanagement/ownland";
import AdminMou from "../pages/admin/adminMou/mouList.js";
import AdminMouAdd from "../pages/admin/adminMou/add.js";
import AdminMouView from "../pages/admin/adminMou/view.js";
import AdminMouEdit from "../pages/admin/adminMou/edit.js";
import ChallengesList from "../pages/admin/Challenges/challengesList.js";
import ChallengesView from "../pages/admin/Challenges/view.js";
import AddChallenges from "../pages/admin/Challenges/add.js";
import EditChallenges from "../pages/admin/Challenges/edit.js";
import MarketAnalysisList from "../pages/admin/marketAnalysis/marketAnalysisList.js";
import AddMarketAnalysis from "../pages/admin/marketAnalysis/add.js";
import MarketAnalysisView from "../pages/admin/marketAnalysis/view.js";
import EditMarketAnalysis from "../pages/admin/marketAnalysis/edit.js";

// import Faqs from "../pages/user/faq/faq.js"
import FaqList from "../pages/admin/FAQ/FaqList.js";
import AddFaq from "../pages/admin/FAQ/add.js";
import FaqView from "../pages/admin/FAQ/view.js";
import EditFaq from "../pages/admin/FAQ/edit.js";

import MemberShipList from "../pages/admin/Membership/membershipList.js";
import AddMembership from "../pages/admin/Membership/add.js";
import MembershipView from "../pages/admin/Membership/view.js";
import EditMembership from "../pages/admin/Membership/edit.js";

import EventList from "../pages/admin/events/eventlist";
import EventListOthers from "../pages/admin/events/eventlistOthers.js";
import EventView from "../pages/admin/events/eventdetails";
import EventBooking from "../pages/admin/events/eventbooking.js";
import EventBookingView from "../pages/admin/events/eventbookingdetails.js";
// import PaymentDetails from "../pages/admin/events/paymentdetails"
import GalleryList from "../pages/admin/gallery/images/images";

import VideoList from "../pages/admin/gallery/videos/videos";
import AdvisorsList from "../pages/admin/advisors/advisorslist";
import AdvisorsAdd from "../pages/admin/advisors/add";
import TechPropAdd from "../pages/admin/buisnessIdeas/transferProposal/add";
import AdvisorsEdit from "../pages/admin/advisors/edit.js";
import AdvisorsView from "../pages/admin/advisors/view";
import AdvisorsBulkEmail from "../pages/admin/advisors/bulkEmail";
import AdminView from "../pages/admin/components/view/view";
import Updatereg from "../pages/user/new_user/companies_kspace/updatereg";
import Academyupdate from "../pages/user/academic_institution/institution/manage/updatereg";
import IndiaCompanyRequest from "../pages/user/new_user/companies_india/updaterej";
import keralaCompanyRequest from "../pages/user/new_user/companies_kerala/updatereg";
// import AdminMou from "../pages/admin/adminMou/mouList.js";
// import AdminMouAdd from "../pages/admin/adminMou/add.js";
// import AdminMouView from "../pages/admin/adminMou/view.js";
// import AdminMouEdit from "../pages/admin/adminMou/edit.js.js";
// import MemberShipList from "../pages/admin/Membership/membershipList.js";
// import AddMembership from "../pages/admin/Membership/add.js";
// import MembershipView from "../pages/admin/Membership/view.js";
// import EditMembership from "../pages/admin/Membership/edit.js.js";
import VendorsList from "../pages/admin/AdminVendors/VendorsList.js";
import VendorsBulkEmail from "../pages/admin/AdminVendors/bulkEmail";
import BulkEmailsList from "../pages/admin/bulkEmails/list";
import BulkEmailDetail from "../pages/admin/bulkEmails/detail";
import VendorView from "../pages/admin/AdminVendors/view.js";
// import AreaType from "../pages/admin/areamanagement/AreaTypes/AreaList.js";
import AreaType from "../pages/admin/areamanagement/AreaTypes/AreaList.js";
import RentArea from "../pages/admin/areamanagement/BuildingRentArea/AreaList.js";
// import FaqList from "../pages/admin/FAQ/FaqList.js";
// import AddFaq from "../pages/admin/FAQ/add.js";
// import FaqView from "../pages/admin/FAQ/view.js";
import EditView from "../pages/admin/FAQ/edit.js";

// Public Pages

import Home from "../pages/public/home/home";
import Events from "../pages/public/events/events.js";
import GalleryImages from "../pages/public/gallery/gallery";
import Advisors from "../pages/public/advisors/list";
import GoverningBody from "../pages/public/governingBody/list";
import ExecutiveCouncil from "../pages/public/executiveCouncil/list";
import CoreTeam from "../pages/public/coreTeam/list";
import GalleryVideo from "../pages/public/gallery/video";
import Careers from "../pages/public/careers/careers";
import Policies from "../pages/public/policies/policies";
import EventDetails from "../pages/public/events/eventsDetails";
import ChallengesOpportunities from "../pages/public/challengesOpportunities/challengesOpportunities";
import VerifiedRoute from "./components/verifiedRoute";
import Disclaimer from "../pages/public/disclaimer/disclaimer";
import NotAuthorized from "../pages/public/error/notauthorized";

import ScrollToTop from "../hoc/scrollToTop";
import Terms from "../pages/public/termsConditions/disclaimer";
import PrivacyPolicy from "../pages/public/privacyPolicy/disclaimer";
import GovOrders from "../pages/public/g0Orders/tenders";
import Resourceupdate from "../pages/user/resource_personal/manage/updatereg";
import Expertupdate from "../pages/user/expert_manpower/manage/updatereg";
import Candidateupdate from "../pages/user/candidates/manage/updatereg.js";
import Vendorupdate from "../pages/user/vendors/institution/manage/updatereg.js";
import EditCompanyRequest from "../pages/admin/companiesInternational/update";
import EditIndiaRequest from "../pages/admin/companiesIndia/update";
import EditKeralaRequest from "../pages/admin/companiesKerala/update";
import Launch from "../pages/public/launch/launch";
import LaunchRoute from "./components/launch";
import PrivateTenders from "../pages/user/tendersprivate/tenders.js";
import Qualifications from "../pages/user/resource_personal/manage/components/qualifications.js";
import { qualifications_list } from "../pages/user/user.api.js";
// import EditFaq from "../pages/admin/FAQ/edit.js.js";
import EditCompanyPremises from "../pages/admin/companyRequest/update.js";
import EditAcademic from "../pages/admin/academicInstitution/academicInstitution/update.js";
import VendorList from "../pages/user/vendor_directory/list.js";
import CompanyUsersDirectory from "../pages/user/companyUsers/directory.js";
import CompanyUserView from "../pages/user/companyUsers/view.js";
import CompanyUserManage from "../pages/user/companyUsers/manage.js";
import VendorPayment from "../pages/public/vendorsPayment/vendorPayment.js";
import ApplicationResponse from "../pages/public/applicationResponse/applicationResponse.js";
import TechnoTransferCategory from "../pages/admin/TechnoTransferCategory/tenderCategory.js";
import TechnoTransferOrganisation from "../pages/admin/TechnoTransferOrganisation/tenderCategory.js";
import RentAreaHistory from "../pages/admin/areamanagement/BuildingRentAreaHistory/AreaList.js";
import LandAllocationHistory from "../pages/admin/areamanagement/BuildingRentAreaHistory/AreaLand.js";

// export default function KspaceRouter(props) {
//   let location = useLocation();

class KspaceRouter extends Component {
  constructor(props) {
    super(props);
    this.state = { pathname: null };
  }

  updateRoute(pathname) {
    this.setState({ pathname });
  }
  render() {
    return (
      <>
        <ScrollToTop onRouteChange={this.updateRoute.bind(this)} />
        <Switch>
          {/* Pages that everyone have access */}

          <PublicRoute path="/" exact {...this.props} component={Home} />
          <PublicRoute path="/home" {...this.props} exact component={Home} />
          <PublicRoute
            path="/events"
            {...this.props}
            exact
            component={Events}
          />
          <PublicRoute
            path="/vendor-payment-submission/:id"
            {...this.props}
            exact
            component={VendorPayment}
          />
          <PublicRoute
            path="/advisors"
            {...this.props}
            exact
            component={Advisors}
          />
          <PublicRoute
            path="/governing-body"
            {...this.props}
            exact
            component={GoverningBody}
          />
          <PublicRoute
            path="/executive-council"
            {...this.props}
            exact
            component={ExecutiveCouncil}
          />
          <PublicRoute
            path="/core-team"
            {...this.props}
            exact
            component={CoreTeam}
          />
          <PublicRoute
            path="/careers"
            {...this.props}
            exact
            component={Careers}
          />
          <PublicRoute
            path="/challenges-oppurtunities"
            {...this.props}
            exact
            component={ChallengesOpportunities}
          />
          <PublicRoute
            path="/policies"
            {...this.props}
            exact
            component={Policies}
          />
          <PublicRoute
            path="/news"
            {...this.props}
            exact
            component={NewsLists}
          />
          <PublicRoute
            path="/incentives"
            {...this.props}
            exact
            component={Incentives}
          />
          <PublicRoute
            path="/terms&conditions"
            {...this.props}
            exact
            component={Terms}
          />
          <PublicRoute
            path="/privacy-policy"
            {...this.props}
            exact
            component={PrivacyPolicy}
          />
          <PublicRoute
            path="/orders"
            {...this.props}
            exact
            component={GovOrders}
          />
          <PublicRoute
            path="/disclaimer"
            {...this.props}
            exact
            component={Disclaimer}
          />
          <PublicRoute
            path="/not-authorized"
            {...this.props}
            exact
            component={NotAuthorized}
          />
          <PublicRoute
            path="/company/application-response/:id"
            {...this.props}
            exact
            component={ApplicationResponse}
          />
          <LaunchRoute
            path="/welcome"
            {...this.props}
            exact
            component={Launch}
          />
          {/* --------------------------- */}

          <PrivateRoute
            path="/training-list"
            {...this.props}
            exact
            component={TrainingList}
          />
          <PublicRoute
            path="/training-detail/:id"
            {...this.props}
            exact
            component={TrainingDetail}
          />
          <PublicRoute
            path="/institute-list"
            {...this.props}
            exact
            component={InstituteList}
          />
          <PublicRoute
            path="/student-proposal-directory"
            {...this.props}
            exact
            component={ProposalDirectory}
          />
          <PublicRoute
            path="/professional-bodies"
            {...this.props}
            exact
            component={ProfessionalBodies}
          />
          <PublicRoute
            path="/vendor-directory"
            {...this.props}
            exact
            component={VendorList}
          />
          <PublicRoute
            path="/directory-company-users"
            {...this.props}
            exact
            component={CompanyUsersDirectory}
          />
          <PrivateRoute
            path="/directory-company-users/:id"
            component={CompanyUserView}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/directory-company-users/add"
            component={CompanyUserManage}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/directory-company-users/edit/:id"
            component={CompanyUserManage}
            {...this.props}
            exact
          />

          <PublicRoute
            path="/contact"
            {...this.props}
            exact
            component={Contact}
          />
          <PublicRoute path="/faq" {...this.props} exact component={Faqs} />

          <PublicRoute
            path="/proposal-list"
            {...this.props}
            exact
            component={ProposalList}
          />
          {/* ----------------------- */}
          <PublicRoute
            path="/gallery/images"
            {...this.props}
            exact
            component={GalleryImages}
          />

          <PublicRoute
            path="/gallery/video"
            {...this.props}
            exact
            component={GalleryVideo}
          />
          <PublicRoute
            path="/event/:id"
            {...this.props}
            exact
            component={EventDetails}
          />
          <PublicRoute
            path="/news-detail/:id"
            {...this.props}
            exact
            component={News}
          />
          <PublicRoute
            path="/directory-international"
            {...this.props}
            exact
            component={DirectoryofCompany}
          />
          <PublicRoute
            path="/directory-india"
            {...this.props}
            exact
            component={Directoryindia}
          />
          <PublicRoute
            path="/directory-kerala"
            {...this.props}
            exact
            component={Directorykerala}
          />
          <PublicRoute path="/faq" {...this.props} exact component={Faqs} />
          <PublicRoute
            path="/directory-kspace"
            {...this.props}
            exact
            component={Directorykspace}
          />
          <PublicRoute
            path="/directory-kspace-own"
            {...this.props}
            exact
            component={DirectoryOwnPremises}
          />
          <PublicRoute
            path="/directory-kspace/completed-kspace"
            {...this.props}
            exact
            component={ViewCompletedKspace}
          />
          <PublicRoute
            path="/directory-kspace/completed-own"
            {...this.props}
            exact
            component={ViewCompletedOwn}
          />
          <PublicRoute
            path="/directory-kspace/:id"
            {...this.props}
            exact
            component={DirectoryOngoing}
          />
          <PublicRoute
            path="/tenders"
            component={Tenders}
            {...this.props}
            exact
          />
          <PublicRoute
            path="/public-internship-proposals"
            component={InternshipProposalsList}
            {...this.props}
            exact
          />
          <PublicRoute
            path="/public-internship-proposals/:id"
            component={InternshipProposalDetail}
            {...this.props}
            exact
          />
          <PublicRoute
            path="/directory-internships-completed"
            component={CompletedInternshipDirectory}
            {...this.props}
            exact
          />
          <PublicRoute
            path="/directory-internships-absorbed"
            component={AbsorbedInternshipDirectory}
            {...this.props}
            exact
          />
          {/* /////////////// Verified Users Only */}
          <VerifiedRoute
            path="/submit-proposal"
            component={ProjectProposal}
            exact
            {...this.props}
          />

          {/* //////////////////////////////////////// */}
          <RegRoute
            path="/resource-personal-reg"
            component={ResourcePersonalReg}
            exact
            {...this.props}
          />
          <RegRoute
            path="/expert-manpower-reg"
            component={ExpertManpowerReg}
            exact
            {...this.props}
          />
          <RegRoute
            path="/candidates-reg"
            component={CandidatesReg}
            exact
            {...this.props}
          />
          {/* <PublicRoute
            path="/candidates-reg"
            component={CandidatesReg}
            exact
            {...this.props}
          /> */}

          <RegRoute
            path="/training-reg"
            component={TrainingReg}
            exact
            {...this.props}
          />
          <RegRoute
            path="/register-kerala"
            component={Registrationkerala}
            exact
            {...this.props}
          />

          {/* <PrivateRoute
            path="/training-reg"
            specialAccess={[8, 21]}
            component={TrainingReg}
            exact
            {...this.props}
          /> */}
          <PrivateRoute
            path="/update-vendors"
            // specialAccess={[8]}
            component={VendorsUpdate}
            exact
            {...this.props}
          />
          {/* <PrivateRoute
            path="/proposal-submit"
            component={ProposalReg}
            exact
            {...this.props}
          /> */}
          <RegRoute
            path="/proposal-submit"
            component={ProposalReg}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/update-kspace"
            // specialAccess={[8]}
            component={Updatereg}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/update-kerala"
            // specialAccess={[8]}
            component={keralaCompanyRequest}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/update-india"
            // specialAccess={[8]}
            component={IndiaCompanyRequest}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/update-academy"
            // specialAccess={[8]}
            component={Academyupdate}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/update-resource"
            // specialAccess={[8]}
            component={Resourceupdate}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/trade-enquiries"
            // specialAccess={[8]}
            component={PrivateTenders}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/update-manpower"
            // specialAccess={[8]}
            component={Expertupdate}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/update-candidate"
            // specialAccess={[8]}
            component={Candidateupdate}
            exact
            {...this.props}
          />
          {/* <PrivateRoute
            path="/update-vendor"
            // specialAccess={[8]}
            component={Vendorupdate}
            exact
            {...this.props}
          /> */}

          <RegRoute
            path="/institute-reg"
            component={InstituteReg}
            exact
            {...this.props}
          />
          <RegRoute
            path="/vendors-reg"
            component={VendorsReg}
            exact
            {...this.props}
          />
          <RegRoute
            path="/update-vendor"
            // specialAccess={[8]}
            component={Vendorupdate}
            exact
            {...this.props}
          />

          <RegRoute
            path="/register-india"
            component={Registrationindia}
            exact
            {...this.props}
          />

          <RegRoute
            path="/register-kspace"
            component={Registrationkspace}
            exact
            {...this.props}
          />

          <RegRoute
            path="/new-company/:id"
            component={NewCompanyRequest}
            exact
            {...this.props}
          />
          {/* <PublicRoute
            path="/new-company/:id"
            component={NewCompanyRequest}
            exact
            {...this.props}
          /> */}
          {/* <RegRoute
            path="/vendor-registration"
            component={VendorEdit}
            exact
            {...this.props}
          /> */}

          <PrivateRoute
            path="/vendor-registration"
            component={VendorEdit}
            exact
            {...this.props}
          />

          {/* PrivateRoute versions for logged-in users to submit new applications */}
          <PrivateRoute
            path="/apply/new-company/:id"
            component={NewCompanyRequest}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/apply/register-kerala"
            component={Registrationkerala}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/apply/register-india"
            component={Registrationindia}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/apply/register-kspace"
            component={Registrationkspace}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/apply/institute-reg"
            component={InstituteReg}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/apply/vendors-reg"
            component={VendorsReg}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/apply/resource-personal-reg"
            component={ResourcePersonalReg}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/apply/expert-manpower-reg"
            component={ExpertManpowerReg}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/apply/candidates-reg"
            component={CandidatesReg}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/apply/training-reg"
            component={TrainingReg}
            exact
            {...this.props}
          />
          <PrivateRoute
            path="/apply/proposal-submit"
            component={ProposalReg}
            exact
            {...this.props}
          />

          <PrivateRoute
            path="/dashboard"
            component={DashBoard}
            {...this.props}
            specialAccess={[0, 4, 5, 6, 8, 9, 10, 24]}
            exact
          />
          <PrivateRoute
            path="/kspace-messages"
            component={KSpaceMessages}
            {...this.props}
            exact
          />
          {/* <PrivateRoute path="/directoryofcompanies" component={DirectoryofCompany } {...this.props} exact /> */}

          <PublicRoute
            path="/publications"
            component={Publications}
            {...this.props}
            exact
          />

          <PublicRoute
            path="/resource-personal"
            component={ResourcePersonalList}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/resource-personal/:id"
            component={ResourcePersonalDetails}
            {...this.props}
            exact
          />
          <PublicRoute
            path="/expert-manpower"
            component={ExpertManpowerList}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/kspace-advisors"
            component={KSPACEAdvisors}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/candidates"
            component={Candidates}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/candidate-profiles"
            component={CandidateProfiles}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/internship-proposals"
            component={InternshipProposalsList}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/internship-proposals/:id"
            component={InternshipProposalDetail}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/internship-proposals/:id/applicant/:proposalId"
            component={InternshipApplicantProfile}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/internship-applied"
            component={RegisteredInternships}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/internship-applied/:id"
            component={InternshipApplicationDetails}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/internship-history"
            component={RegisteredInternshipsHistory}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/internship-proposals-form"
            component={InternshipProposalsForm}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/business-proposal-list"
            component={BusinessProposalList}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/tech-transfer-proposal-list"
            component={TechTransProposalList}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/expert-manpower/:id"
            component={ExpertManpowerDetails}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/kspace-advisors/:id"
            component={AdvisorDetails}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/candidate-view/:id"
            component={CandidateDetails}
            {...this.props}
            exact
          />
          <PrivateRoute
            path="/candidate-details-view/:id"
            component={CandidateDownloadedDetails}
            {...this.props}
            exact
          />

          {/* <PrivateRoute
            path="/resource-personal-reg"
            component={ResourcePersonalReg } {...this.props} exact
          /> */}
          {/* <PrivateRoute path="/news-detail" component={News } {...this.props} exact /> */}

          {/* <PrivateRoute
            path="/new-company"
            component={NewCompanyRequest } {...this.props} exact
          /> */}
          <PrivateRoute
            path="/update-company"
            component={UpdateCompanyRequest}
            {...this.props}
            exact
          />

          <AdminRoute
            path="/professionalbodies-list"
            component={ProfessionalBodiesList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/company-request-list/:id"
            component={RequestList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/bulk-email/:id"
            component={BulkEmail}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/superadmin-company-request-view/:id/:id2"
            component={SuperRequestList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/company-request-view/:id/:id2"
            component={RequestView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/academicinstitution-list"
            component={AcademicInstitutionList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/bulk-email-institutions"
            component={AcademicInstitutionBulkEmail}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/academicinstitution-view/:id"
            component={AcademicInstitutionView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/institution-add"
            component={AcademicInstitutionAdd}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/institutionproposal-list"
            component={InstitutionProposalList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/institutionproposal-view/:id"
            component={InstitutionProposalView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/intershiptraining-list"
            component={IntershipTrainingList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/intershiptraining-view/:id"
            component={IntershipTrainingView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/intershiptraining-add"
            component={IntershipTrainingAdd}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-internship-requests"
            component={AdminInternshipRequestsList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-internship-requests/:id"
            component={AdminInternshipRequestDetail}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-internship-applications"
            component={InternshipApplicationsList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-internship-applications/:id"
            component={InternshipApplicationDetail}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-internships-doing"
            component={InternshipsDoingList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-internships-completed"
            component={InternshipsCompletedList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-internships-absorbed"
            component={InternshipsAbsorbedList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/banner-list"
            component={BannerList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/policies-list"
            component={PoliciesList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/incentives-list"
            component={IncentivesList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/news-list"
            component={NewsList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/banner-add"
            component={BannerAdd}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/scrolling-list"
            component={ScrollList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/accomplishment-list"
            component={AccomplishmentList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/advertisement-list"
            component={AdvertisementList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/advertisements/:id"
            component={AdvertisementDetails}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/advertisements/edit/:id"
            component={AdvertisementEdit}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/advertisement/add"
            component={AdvertisementAdd}
            {...this.props}
            exact
          />

          <AdminRoute
            path="/scope-activity-list"
            component={ScopeList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/quotes-list"
            component={QuoteList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/maintext-list"
            component={MaintextList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/organization-list"
            component={OrganizationList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/domain-list"
            component={DomainList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/qualifications-list"
            component={QualificationList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/tenderCategory-list"
            component={TenderCategoryList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/tenderOrganization-list"
            component={TenderOrganizationList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/techo-transfer-category-list"
            component={TechnoTransferCategory}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/techo-transfer-organization-list"
            component={TechnoTransferOrganisation}
            {...this.props}
            exact
          />

          <AdminRoute
            path="/kerala-companies-list"
            component={CompaniesKeralaList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/bulk-email-kerala"
            component={CompaniesKeralaBulkEmail}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/newrequest-application-kspace"
            component={CompaniesNewKspace}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/newrequest-application-kerala"
            component={CompaniesNewKerala}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/newrequest-application-india"
            component={CompaniesNewIndia}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/newrequest-application-international"
            component={CompaniesNewInternational}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/view-application-kerala/:id"
            component={CompaniesNewViewKerala}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/view-application-india/:id"
            component={CompaniesNewViewIndia}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/view-application-international/:id"
            component={CompaniesNewViewInternational}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/edit-application-premises/:id"
            component={EditCompanyPremises}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/edit-application-international/:id"
            component={EditCompanyRequest}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/edit-application-kerala/:id"
            component={EditKeralaRequest}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/edit-application-india/:id"
            component={EditIndiaRequest}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/view-application-kspace/:id"
            component={CompaniesNewViewKspace}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/companies-in-kspace"
            component={CompaniesInKspace}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/india-companies-list"
            component={CompaniesIndiaList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/international-companies-list"
            component={CompaniesInternationalList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/resource-list"
            component={ResourceList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/bulk-email-resource-personnel"
            component={ResourceBulkEmail}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/resource-view/:id"
            component={ResourceView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/resource-add"
            component={ResourceAdd}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/vendors-list"
            component={VendorsList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/bulk-email-vendors"
            component={VendorsBulkEmail}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/bulk-emails"
            component={BulkEmailsList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/bulk-emails/:uuid"
            component={BulkEmailDetail}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/vendor-view/:id"
            component={VendorView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/manpower-list"
            component={ManpowerList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/bulk-email-expert-manpower"
            component={ManpowerBulkEmail}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/candidates-list/:id"
            component={CandidatesList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/candidates-list"
            component={CandidatesList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/bulk-email-job-seekers/:id"
            component={CandidatesBulkEmail}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/candidates-view/:id"
            component={CandidateView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/candidates-view/:id/:id2"
            component={CandidateView}
            {...this.props}
            exact
          />

          <AdminRoute
            path="/profiles-list"
            component={ProfilesList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/detailed-profiles-list/:id"
            component={DetailedProfileList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/profile-view/:id/:id2"
            component={ProfilesView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/manpower-add"
            component={ManpowerAdd}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/manpower-view/:id"
            component={ManpowerView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/professional-add"
            component={ProfessionalAdd}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/professional-edit"
            component={ProfessionalEdit}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/professional-view"
            component={ProfessionalView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/tender-list"
            component={TenderList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/trade-list"
            component={TradeList}
            {...this.props}
            exact
          />

          <AdminRoute
            path="/career-list"
            component={CareerList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/publication-list"
            component={PublicationList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/project-proposal-list"
            component={ProjectProposalList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/project-proposal-view/:id"
            component={ProjectProposalView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/transfer-proposal-list"
            component={TransferProposalList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/technology-proposal-view/:id"
            component={TransferProposalView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/event-list-kspace"
            component={EventList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/event-list-others"
            component={EventListOthers}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/event-list/:id"
            component={EventView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/event-booking"
            component={EventBooking}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/event-booking/:id"
            component={EventBookingView}
            {...this.props}
            exact
          />

          {/* <AdminRoute
            path="/payment-details"
            component={PaymentDetails}
            {...this.props}
            exact
          /> */}

          <AdminRoute
            path="/images"
            component={GalleryList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/videos"
            component={VideoList}
            {...this.props}
            exact
          />

          <AdminRoute
            path="/advisors-list"
            component={AdvisorsList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/advisors-add"
            component={AdvisorsAdd}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/tech-prop-add"
            component={TechPropAdd}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/advisors-edit/:id"
            component={AdvisorsEdit}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/advisors-view/:id"
            component={AdvisorsView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/advisors-bulk-email"
            component={AdvisorsBulkEmail}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-mou"
            component={AdminMou}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-mou-add"
            component={AdminMouAdd}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-mou-view/:id"
            component={AdminMouView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-mou-edit/:id"
            component={AdminMouEdit}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/academic-edit/:id"
            component={EditAcademic}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/membership"
            component={MemberShipList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/membership-add"
            component={AddMembership}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/membership-view/:id"
            component={MembershipView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/membership-edit/:id"
            component={EditMembership}
            {...this.props}
            exact
          />
          {/* <AdminRoute
            path="/faq-list"
            component={FaqList}
            {...this.props}
            exact
          /> */}
          <AdminRoute
            path="/faq-add"
            component={AddFaq}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/faq-view/:id"
            component={FaqView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/faq-edit/:id"
            component={EditFaq}
            {...this.props}
            exact
          />

          <AdminRoute
            path="/area-types"
            component={AreaType}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/rent-area"
            component={RentArea}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/space-allocation-details"
            component={RentAreaHistory}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/land-allocation-details"
            component={LandAllocationHistory}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/builtup-space"
            component={BuiltUp}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/equip-facility"
            component={EquipedFacilty}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/land-lease"
            component={LandOnLease}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/joint-venture"
            component={JoinrVenture}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/own-land"
            component={OwnLand}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-dashboard"
            component={AdminDashboard}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/login-analytics"
            component={LoginAnalytics}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/login-logs"
            component={LoginLogs}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/login-logs/:id"
            component={LoginLogDetails}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/faq-list"
            component={FaqList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/faq-add"
            component={AddFaq}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/faq-view/:id"
            component={FaqView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/faq-edit/:id"
            component={EditFaq}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-mou"
            component={AdminMou}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-mou-add"
            component={AdminMouAdd}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-mou-view/:id"
            component={AdminMouView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-mou-edit/:id"
            component={AdminMouEdit}
            {...this.props}
            exact
          />

          <AdminRoute
            path="/membership"
            component={MemberShipList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/membership-add"
            component={AddMembership}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/membership-view/:id"
            component={MembershipView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/membership-edit/:id"
            component={EditMembership}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/challenges"
            component={ChallengesList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/challenges-add"
            component={AddChallenges}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/challenges-view/:id"
            component={ChallengesView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/challenges-edit/:id"
            component={EditChallenges}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/market-analysis"
            component={MarketAnalysisList}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/market-analysis-add"
            component={AddMarketAnalysis}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/market-analysis-view/:id"
            component={MarketAnalysisView}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/market-analysis-edit/:id"
            component={EditMarketAnalysis}
            {...this.props}
            exact
          />
          <AdminRoute
            path="/admin-view"
            component={AdminView}
            {...this.props}
            exact
          />

          <AuthRoute
            path="/registration"
            component={SignUp}
            {...this.props}
            exact
          />
          <AuthRoute path="/login" component={Login} {...this.props} exact />
          <AuthNoLayoutRoute
            path="/user-login"
            component={Userlogin}
            {...this.props}
            exact
          />
          <AuthRoute path="/verify" component={Verify} {...this.props} exact />
          <AuthRoute path="/otp" component={Otp} {...this.props} exact />
          <PrivateRoute path="/switch-account" component={SwitchAccount} {...this.props} exact />
          <AdminAuthRoute
            path="/admin-login"
            component={AdminLogin}
            {...this.props}
            exact
          />
          <CompanyAuthRoute
            path="/company-login"
            component={CompanyLogin}
            {...this.props}
            exact
          />
          <ErrorRoute path="*" {...this.props} />

          {/* ----------------------------------------------------------------------------------------------------------------- */}
        </Switch>
      </>
    );
  }
}
export default KspaceRouter;
